







































































































import {Component, Vue} from 'vue-property-decorator';
import {CartItem as CartItemModel, PaymentMethod, PayPalCustomerVault, QuoteAddress} from '@/store/models';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import ui from '@/store/modules/ui';
import user from '@/store/modules/user';
import OneyRates from '@/components/Cart/OneyRates.vue';
import HipayCard from '@/components/Checkout/PaymentStep/HipayCard.vue';
import HipayApplePay from '@/components/Checkout/PaymentStep/HipayApplePay.vue';
import StripeStep from '@/components/Checkout/PaymentStep/StripeStep.vue';
import store from '@/store';
import {get as dataGetter} from 'lodash';
import {deletePaypalCustomerVault} from '@/store/api';
import device from '@/store/modules/device';
import handleMessage from '@/commons/messageManager';
import payment from '@/store/modules/payment';
import stripe from '@/store/modules/stripe';

@Component({
    computed: {
        StripeStep() {
            return StripeStep
        }
    },
    components: {
        StripeStep,
        OneyRates,
        HipayCard,
        HipayApplePay,
    },
})
export default class PaymentMethodSelection extends Vue {
    public deletingCard = false;
    private oney: any = false;
    private isShowListFirstTime: any = false;

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get grandTotal(): number {
        const grandTotal = cart.totals.total_segments.find((total) => total.code === 'grand_total');
        return grandTotal ? grandTotal.value : 0;
    }

    get selected(): string {
        return checkout.selectedPaymentMethod ? checkout.selectedPaymentMethod.code : '';
    }

    set selected(value: string) {
        checkout.setPayment(value);
    }

    get methods(): PaymentMethod[] {
        const customOrder: any = {
            stripe_payments: 1,
            hipay: 10,
            hipay_applepay: 15,
            wf_cashondelivery: 20,
            wf_paypal: 30,
            wf_paypalpaylater: 40,
            scalapay: 50,
            payin4: 60,
            banktransfer: 70,
            hipay_moto: 999,
            hipay_paybylink: 999,
            stripe_payments_moto: 999,
        };

        checkout.paymentMethods.sort((a, b) => {
            return customOrder[a.code] - customOrder[b.code];
        });

        const methodFinded = checkout.paymentMethods.find((method: any) => method.code === 'hipay_applepay');
        if (methodFinded && payment.registry.includes('hipay_applepay') && !checkout.canMakeApplePayPayments) {
            checkout.setPaymentMethods(
                checkout.paymentMethods.filter((method: PaymentMethod) => method.code !== 'hipay_applepay'),
            );
        }

        return this.fixTitles(checkout.paymentMethods);
    }

    get address(): QuoteAddress {
        return checkout.shippingAddress;
    }

    get items(): CartItemModel[] {
        return cart.cart.items;
    }

    get storeCode(): string {
        return store.state.options.locale;
    }

    get regionsNotAllowedForPayment(): any {
        return store.state.options.regions.not_allowed;
    }

    get isAppPayPalEnabled(): boolean {
        return store.state.options.app_paypal_enabled;
    }

    get isWfAppPayPalEnabled(): boolean {
        return store.state.options.wf_app_paypal_enabled;
    }

    get paypalVaults() {
        return user.customer.extension_attributes.wfpaypal_vaults
            ? user.customer.extension_attributes.wfpaypal_vaults
            : [];
    }

    set paypalVaults(value: PayPalCustomerVault[]) {
        user.customer.extension_attributes.wfpaypal_vaults = value;
    }

    get stripePaymentMethods() {
        const stripePaymentMethods = stripe.config!.payment_methods || [];
        let result: string[] = [];

        stripePaymentMethods.forEach((paymentMethod: string) => {
            switch (paymentMethod) {
                case 'card':
                case 'card_present':
                    result.push('stripe_card');
                    break;

                case 'apple_pay':
                    result.push('applepay');
                    break;

                case 'google_pay':
                    result.push('googlepay');
                    break;

                case 'amazon_pay':
                    result.push('amazonpay');
                    break;

                case 'paypal':
                case 'paynow':
                    result.push('paypal');
                    break;

                case 'klarna':
                case 'bancontact':
                    result.push(paymentMethod);
                    break;

                default:
                    break;
            }
        });
        // Remove duplicates
        result = result.filter((item, index) => result.indexOf(item) === index);

        return result;
    }

    public fixTitles(paymentMethods: PaymentMethod[]): PaymentMethod[] {
        const klarnaConfigs = dataGetter(store.state.options.payment, 'klarna.payment');
        if (paymentMethods && klarnaConfigs !== undefined) {
            paymentMethods.forEach((method: PaymentMethod) => {
                // eslint-disable-next-line no-prototype-builtins
                if (klarnaConfigs.hasOwnProperty(method.code)) {
                    method.title = klarnaConfigs[method.code].title;
                }
            });
        }

        return paymentMethods;
    }

    public checkRegionAllowed(methodCode: string): boolean {
        if (methodCode === 'wf_cashondelivery') {
            const find = this.regionsNotAllowedForPayment.find((region: string) => region === this.address.region);
            if (find) {
                const methodFinded = checkout.paymentMethods.find((method: any) => method.code === 'wf_paypal');
                if (methodFinded && !this.isShowListFirstTime) {
                    this.selected = 'wf_paypal';
                    this.isShowListFirstTime = true;
                }
                return false;
            }
            return true;
        }
        return true;
    }

    public getPaymentMethodImage(paymentMethod: PaymentMethod) {
        let paymentMethodImage;

        const paymentMethodCode = paymentMethod.code.replace(/wf_|hipay_/g, '');

        switch (paymentMethodCode) {
            case 'banktransfer':
            case 'cashondelivery':
                paymentMethodImage = `${paymentMethodCode}-${this.storeCode}`;
                break;

            case 'payin4':
                paymentMethodImage = 'scalapay';
                break;

            case 'paybylink':
            case 'moto':
            case 'stripe_payments_moto':
                paymentMethodImage = '';
                break;

            case 'klarna_alt_ideal':
            case 'klarna_pay_now':
            case 'klarna_pay_later':
            case 'klarna_pay_over_time':
            case 'klarna_klarna':
                paymentMethodImage = 'klarna';
                break;

            case 'paypalpaylater':
                paymentMethodImage = 'paypal';
                break;

            default:
                paymentMethodImage = paymentMethodCode;
                break;
        }

        return paymentMethodImage;
    }

    public async deletePaypalVault() {
        if (this.paypalVaults && this.paypalVaults.length) {
            this.deletingCard = true;

            const status = await deletePaypalCustomerVault(this.paypalVaults[0].vault_id);

            this.deletingCard = false;

            if (status === 200) {
                this.paypalVaults = [];
            } else {
                handleMessage(
                    'error',
                    this.$t('There was an error deleting your card, please try again later').toString(),
                );
            }
        }
    }

    public filterPaymentMethod(methodCode: string) {
        if (['wf_paypal', 'wf_paypalpaylater'].includes(methodCode)) {
            if (device.isAndroidOldApp && !this.isAppPayPalEnabled) {
                return false;
            }
            if (device.isAndroidWfApp && !this.isWfAppPayPalEnabled) {
                return false;
            }

            return true;
        }

        return true;
    }

    private isActive(method: PaymentMethod): boolean {
        return method.code === this.selected;
    }

    private getDescription(methodCode: string): string {
        const paymentDescription = checkout.paymentDescriptions.find((m) => {
            return m.code === methodCode;
        });
        return paymentDescription ? paymentDescription.description : '';
    }

    private mounted() {
        if (window as any) {
            this.oney = (window as any).oney;
        }

    }

    private openModal(modalId: string) {
        ui.openModal(modalId);
    }

    private canShowHipayCard(method: PaymentMethod): boolean {
        const hipayConfig = store.state.options.payment.hipay;
        const active = method.code === 'hipay' && this.isActive(method);
        return active && ((hipayConfig.show_tokenized_cards && this.isLogged) || hipayConfig.use_hostedfields);
    }

    private canShowApplePay(method: PaymentMethod): boolean {
        return method.code === 'hipay_applepay' && this.isActive(method);
    }

    private canShowStripe(method: PaymentMethod): boolean {
        return method.code === 'stripe_payments' && this.isActive(method);
    }
}
